import { useEffect } from "react";
import { ContainerV2, H1, InputRHFV2, P } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { useVehicleV2 } from "./useVehicleV2";

export const VehicleV2 = () => {
  const {
    stepIndicator,
    veiculo,
    podeConfirmar,
    tipoVeiculoLabel,
    handleConfirmar,
  } = useVehicleV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/servicos/veiculo:pageview");
  });

  return (
    <ContainerV2
      nextButton={{
        title: "Avançar",
        disabled: !podeConfirmar,
        onClick: handleConfirmar,
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Identifique o veículo</H1>
      <P className="mb-6 text-[#666666]">
        Consultamos as informações automaticamente. Você só precisa confirmar.
      </P>

      <div className="flex w-full flex-col gap-4 rounded-[10px] border border-solid border-[#e5e5ea] bg-white shadow-[0_8px_24px_0_rgba(0,0,0,0.078)]">
        <div className="flex items-center gap-2 border-t-transparent border-x-transparent border-[#e5e5ea] border-solid w-full border-b-[1px] px-4 py-2">
          <img src="/assets/svgs/icon-step-done-outlined.svg" alt="" />
          <span className="font-['Mulish'] text-xs text-[#20332f]">
            Veículo encontrado
          </span>
        </div>
        <div className="p-8 flex flex-col gap-4">
          <div className="flex w-full justify-center">
            <div className="flex h-[72px] w-[150px] flex-col overflow-hidden rounded-[5px] border border-solid border-black bg-white">
              <div className="h-[15px] w-full bg-[#0508eb]" />
              <div className="flex flex-1 items-center justify-center">
                <span className="font-['Mulish'] text-xl font-bold text-[#20332f]">
                  {veiculo?.placa ?? ""}
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            <InputRHFV2
              id="modelo"
              label="Modelo"
              readOnly
              value={veiculo?.modelo ?? ""}
            />
            <InputRHFV2
              id="ano"
              label="Ano"
              readOnly
              value={veiculo?.ano ?? ""}
            />
            <InputRHFV2
              id="renavam"
              label="Renavam"
              readOnly
              value={veiculo?.renavam ?? ""}
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <InputRHFV2
              id="chassi"
              label="Chassi"
              readOnly
              value={veiculo?.chassi ?? ""}
            />
            <InputRHFV2
              id="tipoVeiculo"
              label="Tipo de Veículo"
              readOnly
              value={tipoVeiculoLabel}
            />
          </div>
        </div>
      </div>
    </ContainerV2>
  );
};
